import { useState } from "react";
import { List, Card, Space, Typography, Button } from "antd";
import "./ClanakCards.css";
import "../Dokument/DokumentCardsKorisnik.css";
import "../Dokument/DokumentCards.css";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { formatDateTime } from "../../utils/formatDateTime";
import logoDark from "../../img/logo_dark.png";

const { Text } = Typography;

function ClanakCards({ clanci, onDeleteClick, onEditClick }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentClanci = clanci.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(clanci.length / itemsPerPage);
  const handleClickClanak = (clanakId) => {
    navigate(`/clanci/${clanakId}`);
  };

  return (
    <List
      grid={{ gutter: 16, xs: 1, sm: 1, md: 3, lg: 4, xl: 4, xxl: 4 }}
      dataSource={currentClanci}
      locale={{ emptyText: "Nema dostupnih članaka." }}
      renderItem={(clanak, index) => {
        const colors = ["#c9bc8d", "#f7eba8", "#babd7d", "#ded6a0"];
        const backgroundColor = colors[index % colors.length];

        return (
          <List.Item>
            <div className="document-cards-zaposleni">
              <Card
                hoverable
                onClick={() => handleClickClanak(clanak.id)}
                cover={
                  <div
                    className="dokument-card-cover"
                    style={{ backgroundColor, padding: "0" }}
                  >
                    <img
                      src={clanak.slika ? clanak.slika : logoDark}
                      alt="Slika"
                      className="clanak-card-img-korisnik"
                      style={{
                        backgroundColor,
                        objectFit: clanak.slika ? "cover" : "scale-down",
                      }}
                    />
                  </div>
                }
              >
                <div className="dokument-card-title">{clanak.naslov}</div>
                <Space
                  className="document-card-footer-zaposleni"
                  align="center"
                  size={0}
                >
                  <Text type="secondary" className="dokument-card-autor">
                    {clanak.autor}
                  </Text>
                  <Text type="secondary">
                    {formatDateTime(clanak.datumObjave)}
                  </Text>
                  <span>
                    <Button
                      key="edit"
                      icon={<EditOutlined />}
                      onClick={(e) => {
                        e.stopPropagation();
                        onEditClick(clanak.id);
                      }}
                      className="card-action-button"
                      type="text"
                    />

                    <Button
                      key="delete"
                      icon={<DeleteOutlined />}
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteClick(clanak.id);
                      }}
                      className="card-action-button"
                      type="text"
                    />
                  </span>
                </Space>
              </Card>
            </div>
          </List.Item>
        );
      }}
    >
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Prethodna
          </button>

          <span>
            Stranica {currentPage} od {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Sljedeća
          </button>
        </div>
      )}
    </List>
  );
}
export default ClanakCards;
